/**
 * created on: 2019.04.04
 * 电视管理左侧导航
 */
"use strict"
angular.module('televisionManageLeftModule', [])
    .directive('televisionManageLeft', ['$q', 'trsHttpService', '$state', '$stateParams', function($q, trsHttpService, $state, $stateParams) {
        return {
            restirct: "A",
            scope: true,
            replace: false,
            templateUrl: "./manageConfig/productManageMent/television/left/left_tpl.html",
            link: function($scope, $element, $attrs) {
                initStatus();
                initData();

                function initStatus() {
                    $scope.status = {
                        selectedStation: $stateParams.siteid,
                    };
                    $scope.data = {
                        tvStation: [],
                    };
                }

                function initData() {
                    getAllStation();
                }
                /**
                 * [getAllStation 获取所有站点数据]
                 * @return {[type]} [description]
                 */
                function getAllStation() {
                    var params = {
                        serviceid: 'mlf_tvconfig',
                        methodname: 'queryTvSitesForCloud'
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        if (angular.isArray(data)) {
                            $scope.data.tvStation = data;
                        } else {
                            $scope.data.tvStation = data.DATA;
                        }
                    });
                }

                /**
                 * [selectedStation 选择电视台站点]
                 * @param  {[type]} station [description]
                 * @return {[type]}         [description]
                 */
                $scope.selectedStation = function(station) {
                    if ($scope.status.selectedStation == station.SITEID) return;
                    $scope.status.selectedStation = station.SITEID;
                    var router = 'manageconfig.productmanage.television.manage';
                    $state.go(router, { siteid: station.SITEID });
                };


            }
        };
    }]);